export type ProjectAbstract = {
  id: number;
  organisationId?: number;
  type: ProjectType;
  name: string;
  image: string;
  startDate?: string | null;
  endDate?: string | null;
};
export type ProjectType = 'festival' | 'venue' | 'tour';

export type ModelVersionESS = (typeof ModelVersionESSValues)[number];
export const ModelVersionESSValues = [
  '', // error ?
  'ESS_1',
  'ESS_SEASON',
  'ESS_SEASON_EVENT',
  'ESS_TOUR',
] as const;

export type ModelVersionENV = (typeof ModelVersionENVValues)[number];
export const ModelVersionENVValues = [
  '', // error ?
  'ENV_1',
  'ENV_SEASON',
  'ENV_SEASON_EVENT',
  'ENV_TOUR',
] as const;
